var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIconGuideImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0v32H0V0h32zM11.2 15.782L2 25.027 2 30h28l-.001-6.53-5.064-5.088-5.573 5.601-8.162-8.201zM30 2H2l-.001 20.014 9.202-9.245 8.16 8.2 5.575-5.6 5.063 5.087L30 2zm-7.048 6.363c1.098 0 1.987.896 1.987 1.998 0 1.104-.89 1.997-1.987 1.997-1.098 0-1.988-.893-1.988-1.997 0-1.102.89-1.998 1.988-1.998z"
  })));
}
export default SvgReviewIconGuideImage;